export const not = (value: unknown): boolean => !value;
